<template>
    <div class="container">
        <div class="box-title">
            <h4>
                <i class="fal fa-map-marker-alt"></i>
                ຂໍ້ມູນ ທີ່ຢູ່ຂົນສົ່ງ ( Shipping Addresses )
                <span class="countTotal">({{ pagination.total || 0 }})</span>
                <span class="btn-add">
                    <vs-button circle icon flat @click="OpenModalAdd()">
                        <i class="fal fa-plus-circle"></i>
                    </vs-button>
                </span>
            </h4>
        </div>

        <div class="box">
            <div class="columns is-multiline">
                <div class="column is-3">
                    <div class="control">
                        <label class="label">ຄົ້ນຫາ</label>
                        <input
                            class="input"
                            placeholder="ຊື່ຜູ້ຮັບ / ເບີໂທ / ລະຫັດໄປສະນີ / ເຂດ..."
                            v-model="searchResult"
                            @keyup.enter="ResetPageAndFetch()"
                        >
                    </div>
                </div>
                <div class="column is-2">
                    <div class="control">
                        <label class="label">ປະເພດການຂົນສົ່ງ</label>
                        <div class="select">
                            <select v-model="filterTransportType" @change="ResetPageAndFetch()">
                                <option value="">ທັງໝົດ</option>
                                <option v-for="(t, i) in transportTypes" :key="i" :value="t.id">{{ t.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="column is-2">
                    <div class="control">
                        <label class="label">ປະເທດປາຍທາງ</label>
                        <div class="select">
                            <select v-model="filterAddressCountry" @change="ResetPageAndFetch()">
                                <option value="">ທັງໝົດ</option>
                                <option v-for="(c, i) in addressCountries" :key="i" :value="c.id">{{ c.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="column is-3">
                    <div class="control">
                        <label class="label">ເຂດ/ເມືອງ ( District )</label>
                        <input
                            class="input"
                            placeholder="ປ້ອນຊື່ເຂດ..."
                            v-model="filterAddressDistrict"
                            @keyup.enter="ResetPageAndFetch()"
                        >
                    </div>
                </div>
                <div class="column is-2">
                    <div class="control">
                        <label class="label">ຈຳນວນຕໍ່ໜ້າ</label>
                        <div class="select">
                            <select v-model.number="per_page" @change="ResetPageAndFetch()">
                                <option :value="15">15</option>
                                <option :value="25">25</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="center">
            <vs-table>
                <template #thead>
                    <vs-tr>
                        <vs-th>ລຳດັບ</vs-th>
                        <vs-th>ຫົວຂໍ້ ( Title )</vs-th>
                        <vs-th>ຜູ້ຮັບ</vs-th>
                        <vs-th>ເບີໂທ</vs-th>
                        <vs-th>ເຂດ/ເມືອງ</vs-th>
                        <vs-th>ປະເທດ</vs-th>
                        <vs-th>ການຂົນສົ່ງ</vs-th>
                        <vs-th>ລາຄາ ( Rate )</vs-th>
                        <vs-th></vs-th>
                    </vs-tr>
                </template>
                <template #tbody>
                    <vs-tr :key="index" :data="addr" v-for="(addr, index) in addresses">
                        <vs-td>{{ pagination.from ? pagination.from + index : index + 1 }}</vs-td>
                        <vs-td :style="{ maxWidth: '180px' }">
                            <vs-tooltip>
                                {{ addr.title || '...' }}
                                <template #tooltip>{{ addr.title || '...' }}</template>
                            </vs-tooltip>
                        </vs-td>
                        <vs-td>{{ addr.receiver_name }}</vs-td>
                        <vs-td>{{ addr.phone }}</vs-td>
                        <vs-td>{{ addr.address_district }}</vs-td>
                        <vs-td>{{ countryLabel(addr.address_country) }}</vs-td>
                        <vs-td>{{ transportLabel(addr.transport_type) }}</vs-td>
                        <vs-td>
                            <span v-if="addr.shipping_rate">{{ addr.shipping_rate.shipping_rates }}</span>
                            <span v-else style="color: crimson">ບໍ່ມີລາຄາ</span>
                        </vs-td>
                        <vs-td style="text-align: right; width: 140px">
                            <div class="group-icon">
                                <vs-button circle icon flat color="amazon" @click="OpenModalView(addr.id)">
                                    <i class="fal fa-eye"></i>
                                </vs-button>
                                <vs-button circle icon flat @click="OpenModalEdit(addr.id)">
                                    <i class="fad fa-pencil-alt"></i>
                                </vs-button>
                                <vs-button circle danger icon flat @click="OpenModalDelete(addr.id)">
                                    <i class="fad fa-trash-alt"></i>
                                </vs-button>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
                <template #footer>
                    <pagination
                        v-if="pagination.last_page > 1"
                        :pagination="pagination"
                        :offset="offset"
                        @paginate="FetchData()"
                    />
                    <Loading v-if="isLoading"/>
                </template>
            </vs-table>
        </div>

        <ModalAdd>
            <template v-slot="{ close }">
                <AddShippingAddress @close="close" @success="FetchData()"/>
            </template>
        </ModalAdd>

        <ModalEdit>
            <template v-slot="{ close }">
                <EditShippingAddress :shippingAddress="filterShippingAddress" @close="close" @success="FetchData()"/>
            </template>
        </ModalEdit>

        <ModalDelete>
            <template v-slot="{ close }">
                <DeleteShippingAddress :shippingAddressId="shippingAddressId" @close="close" @success="FetchData()"/>
            </template>
        </ModalDelete>

        <vs-dialog v-model="viewDialog" width="520px">
            <template #header>
                <h4 class="not-margin" :style="{ fontWeight: 'bold', color: '#195BFF' }">
                    ລາຍລະອຽດທີ່ຢູ່
                </h4>
            </template>
            <div v-if="viewItem.id" :style="{ padding: '10px' }">
                <p><b>Title:</b> {{ viewItem.title || '...' }}</p>
                <p><b>ປະເພດການຂົນສົ່ງ:</b> {{ transportLabel(viewItem.transport_type) }}</p>
                <p><b>ປະເທດ:</b> {{ countryLabel(viewItem.address_country) }}</p>
                <p><b>ເຂດ:</b> {{ viewItem.address_district }}</p>
                <p><b>ລະຫັດໄປສະນີ:</b> {{ viewItem.postal_code || '...' }}</p>
                <p :style="{ marginTop: '12px' }"><b>ຂໍ້ມູນສະແດງຜົນ:</b></p>
                <pre :style="{ whiteSpace: 'pre-line', background: '#f7f7f7', padding: '10px', borderRadius: '4px' }">{{ viewItem.text }}</pre>
                <div v-if="viewItem.shipping_rate" :style="{ marginTop: '12px' }">
                    <p><b>ລາຄາ ( Rate ):</b> {{ viewItem.shipping_rate.shipping_rates }}</p>
                    <p><b>ສູດຄິດໄລ່ນ້ຳໜັກ:</b> {{ viewItem.shipping_rate.volumetric_weight_formula }}</p>
                </div>
                <div v-else :style="{ marginTop: '12px', color: 'crimson' }">
                    ບໍ່ມີລາຄາທີ່ຕັ້ງໄວ້ສຳລັບການຂົນສົ່ງນີ້
                </div>
            </div>
        </vs-dialog>
    </div>
</template>

<script>
import Loading from '../../Loading';
import pagination from '../../../Plugins/Paginations/Pagination';
import AddShippingAddress from './Dialog/Add';
import EditShippingAddress from './Dialog/Edit';
import DeleteShippingAddress from './Dialog/Delete';

export default {
    components: {
        Loading,
        pagination,
        AddShippingAddress,
        EditShippingAddress,
        DeleteShippingAddress,
    },
    data: () => ({
        isLoading: true,
        addresses: [],
        filterShippingAddress: {},
        shippingAddressId: '',
        viewDialog: false,
        viewItem: {},

        searchResult: '',
        filterTransportType: '',
        filterAddressCountry: '',
        filterAddressDistrict: '',

        // Pagination
        offset: 10,
        per_page: 15,
        pagination: {},

        transportTypes: [
            { id: 'normal', name: 'ປົກກະຕິ ( Normal )' },
            { id: 'air_freight', name: 'ທາງຍົນ ( Air Freight )' },
            { id: 'railway', name: 'ທາງລົດໄຟ ( Railway )' },
        ],
        addressCountries: [
            { id: 'zh', name: 'ຈີນ ( ZH )' },
            { id: 'th', name: 'ໄທ ( TH )' },
        ],
    }),
    methods: {
        transportLabel(id) {
            const item = this.transportTypes.find(t => t.id === id);
            return item ? item.name : id;
        },
        countryLabel(id) {
            const item = this.addressCountries.find(c => c.id === id);
            return item ? item.name : id;
        },
        OpenModalAdd() {
            this.$store.commit('modalAdd_State', true);
        },
        OpenModalEdit(id) {
            this.filterShippingAddress = { ...this.FilterItem(id) };
            this.$store.commit('modalEdit_State', true);
        },
        OpenModalDelete(id) {
            this.shippingAddressId = id;
            this.$store.commit('modalDelete_State', true);
        },
        OpenModalView(id) {
            this.viewItem = { ...this.FilterItem(id) };
            this.viewDialog = true;
        },
        FilterItem(id) {
            return this.addresses.filter(item => item.id === id)[0] || {};
        },
        ResetPageAndFetch() {
            this.pagination.current_page = 1;
            this.FetchData();
        },
        FetchData() {
            this.isLoading = true;
            const params = { page: this.pagination.current_page || 1, per_page: this.per_page };
            if (this.searchResult) params.search = this.searchResult;
            if (this.filterTransportType) params.transport_type = this.filterTransportType;
            if (this.filterAddressCountry) params.address_country = this.filterAddressCountry;
            if (this.filterAddressDistrict) params.address_district = this.filterAddressDistrict;

            this.$http.get('shipping-address', { params }).then(res => {
                const payload = res.data ? res.data.data : null;
                setTimeout(() => { this.isLoading = false; }, 200);
                setTimeout(() => {
                    let rows = [];
                    let meta = {};
                    if (Array.isArray(payload)) {
                        // Flat array response — no pagination wrapper
                        rows = payload;
                        meta = {
                            current_page: 1,
                            last_page: 1,
                            per_page: this.per_page,
                            from: rows.length ? 1 : 0,
                            to: rows.length,
                            total: rows.length,
                        };
                    } else if (payload && Array.isArray(payload.data)) {
                        // Laravel paginator shape
                        rows = payload.data;
                        meta = payload.meta || {};
                    }
                    this.addresses = rows;
                    this.pagination = {
                        current_page: meta.current_page || 1,
                        last_page: meta.last_page || 1,
                        per_page: meta.per_page || this.per_page,
                        from: meta.from || 0,
                        to: meta.to || 0,
                        total: meta.total || rows.length,
                    };
                }, 100);
            }).catch(() => {
                this.isLoading = false;
            });
        },
    },
    watch: {
        searchResult(value) {
            if (value === '') {
                this.ResetPageAndFetch();
            }
        },
        filterAddressDistrict(value) {
            if (value === '') {
                this.ResetPageAndFetch();
            }
        },
    },
    created() {
        this.FetchData();
    },
};
</script>

<style lang="scss" scoped>
.container {
    margin-top: 40px;

    .title-login {
        font-size: 20px;
        color: $primary-color;
    }

    @media screen and (max-width: 768px) {
        .columns {
            flex-direction: column;
        }
    }
}
</style>
